import {Component, EventEmitter, Input, Output} from '@angular/core';
import {BaseComponent} from "common-shared";

@Component({
  selector: 'app-toolbar-list-buttons',
  templateUrl: './toolbar-list-buttons.component.html',
  styles: [
  ],
  host: {
    class: 'd-flex'
  }
})
export class ToolbarListButtonsComponent extends BaseComponent {
  @Input() showAdd = true;
  @Output() addClick = new EventEmitter<boolean>();

}
